<mat-toolbar>
  <div class="toolbar-buttons">
    <button mat-icon-button [routerLink]="['..', 'settings']">
      <mat-icon aria-label="Settings">settings</mat-icon>
    </button>
  </div>
</mat-toolbar>
<div [ngClass]="isDemoMode ? 'card-container-wide' : 'card-container'">
  <div class="center-content">
    <img src="assets/ftf-logo.png" alt="First To File" class="logo" />
    @if (hasSettingNeededForAuth) {
      <mat-card>
        <mat-card-header>
          <mat-card-title>Please Sign-in</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>To use First To File, please signin. You may need to enable popup dialogs if they are not enabled.</p>
        </mat-card-content>
        <mat-card-actions class="center-button">
          <button mat-button color="primary" (click)="login()">
            <mat-icon>login</mat-icon>
            <span>Sign in</span>
          </button>
        </mat-card-actions>
        @if (isDemoMode) {
          <mat-card-header>
            <mat-card-title>Welcome to the First to File Pre-Release Demo Add-in!</mat-card-title>
          </mat-card-header>
        }
        @if (isDemoMode) {
          <mat-card-content>
            <p>The demo add-in provides early access to upcoming releases for testing and feedback before official production launch.</p>
            <p>
              <strong>Disclaimer:</strong> Demo add-in is for internal evaluation purposes only. Customers may not sell, rent, sublicense,
              or share access to any part of it with third parties.
            </p>
            <p>
              Clarivate is not liable for any actions, errors, data, configurations, or implementations related to the demo add-in.
              Clarivate has no obligation to provide support, maintenance, updates, or modifications for the demo add-in.
            </p>
          </mat-card-content>
        }
      </mat-card>
    } @else {
      <mat-card>
        <mat-card-header>
          <mat-card-title>Please Configure Settings</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>To use First To File, you must first configure the settings.</p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-button color="primary" [routerLink]="['..', 'settings']">
            <mat-icon>settings</mat-icon>
            <span>Settings</span>
          </button>
        </mat-card-actions>
      </mat-card>
    }
  </div>
</div>
